import { ADDRESS } from 'lib/communication';
import { getFile } from 'lib/communication/files';
import useIsMounted from 'lib/hooks/useIsMounted';
import React, { useEffect, useState } from 'react';
import { Image, ImageProps } from 'react-bootstrap';

const SecureImage: React.FC<ImageProps> = ({ src, ...props }) => {
    const [imageSrc, setImageSrc] = useState<string>('_blank');
    const isMounted = useIsMounted();

    const getFileFunc = async (url: string) => {
        if (url.startsWith('blob:') ||
            ((url.includes('http://') || url.includes('https://')) && !url.includes(`${ADDRESS}`)) ||
            !url.includes('storage/')) {
            if (isMounted.current) setImageSrc(url);
            return;
        }
        const tokens = url.split('storage/');
        try {
            const file = await getFile(tokens[tokens.length - 1]);
            if (isMounted.current) {
                setImageSrc(file);
            }
        } catch (err) {
            setImageSrc('');
        }
    };

    useEffect(() => {
        if (!src) return;
        getFileFunc(src);
    }, [src]);

    return (
        <Image
            src={imageSrc}
            {...props}
        />
    );
};

export default SecureImage;
